export const CONFIRMATION_ELEMENT_TYPE = 'confirmation';

/**
 * Returns the confirmation fields of a form-redemption segment configuration, in
 * the order they are configured in Cosmo (which is the drag-to-reorder order of
 * the form inputs).
 *
 * A confirmation is display-only: its markdown lives on `placeholder`, the same
 * slot `text` and `hidden` fields use, and nothing is submitted for it. The
 * fields are deliberately left in `formDataTypes` when the form renders, because
 * `FormBody` returns `null` for element types it has no control for, so they are
 * inert there.
 *
 * Configurations without confirmations (or without `formDataTypes`) give `[]`.
 */
export const getConfirmations = (configuration) => {
  const formDataTypes = configuration?.formDataTypes;

  if (!Array.isArray(formDataTypes)) {
    return [];
  }

  return formDataTypes.filter(
    (field) =>
      field?.elementType === CONFIRMATION_ELEMENT_TYPE && field?.placeholder,
  );
};
